var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBriefcase(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 83,
    height: 83,
    viewBox: "0 0 83 83",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M75.5302 49.9944V67.4529C75.5302 71.9489 72.2977 75.8163 67.8409 76.408C59.2691 77.5461 50.5235 78.1335 41.6405 78.1335C32.7575 78.1335 24.0119 77.5461 15.4401 76.408C10.9832 75.8163 7.7508 71.9487 7.7508 67.4529V49.9944M75.5302 49.9944C77.4687 48.342 78.611 45.8414 78.611 43.1713V27.6305C78.611 23.1901 75.4566 19.3536 71.0651 18.6965C66.4422 18.0048 61.7668 17.4736 57.0449 17.1087M75.5302 49.9944C74.7349 50.6724 73.8055 51.2076 72.766 51.5533C62.9819 54.8061 52.517 56.5673 41.6405 56.5673C30.7642 56.5673 20.299 54.8061 10.5149 51.5531C9.47546 51.2076 8.54612 50.6724 7.7508 49.9944M7.7508 49.9944C5.81223 48.3418 4.66992 45.8412 4.66992 43.1711V27.6305C4.66992 23.1901 7.82435 19.3536 12.2158 18.6965C16.8388 18.0048 21.5141 17.4736 26.2361 17.1087M57.0449 17.1087V13.435C57.0449 8.33046 52.9068 4.19238 47.8022 4.19238H35.4787C30.3741 4.19238 26.2361 8.33046 26.2361 13.435V17.1087M57.0449 17.1087C51.9616 16.716 46.8244 16.5159 41.6405 16.5159C36.4566 16.5159 31.3193 16.716 26.2361 17.1087M41.6405 44.2438H41.6713V44.2746H41.6405V44.2438Z",
    stroke: "url(#paint0_linear_1_57)",
    strokeWidth: 8.21568,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_57",
    x1: 41.6405,
    y1: 4.19238,
    x2: 41.6405,
    y2: 78.1335,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F99A27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF0D2F"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBriefcase);
export default __webpack_public_path__ + "static/media/briefcase.e544e6b43a7d35a24b96b41c5ec69bc1.svg";
export { ForwardRef as ReactComponent };